import { Box, IconButton } from '@chakra-ui/react';
import React from 'react';
import ThumbUpIcon from '../../icons/ThumbIcons/ThumbUpIcon';
import ThumbUpIconFilled from '../../icons/ThumbIcons/ThumbUpIconFilled';
import ThumbDownIcon from '../../icons/ThumbIcons/ThumbDownIcon';
import ThumbDownIconFilled from '../../icons/ThumbIcons/ThumbDownIconFilled';
import ConditionalTooltip from '../Tooltip/ConditionalTooltip';
const RatingButton = ({ isFilled, label, variant, isDisabled, ...rest }) => {
    const Icon = (() => {
        if (variant === 'positive') {
            return isFilled ? React.createElement(ThumbUpIconFilled, null) : React.createElement(ThumbUpIcon, null);
        }
        return isFilled ? React.createElement(ThumbDownIconFilled, null) : React.createElement(ThumbDownIcon, null);
    })();
    return (React.createElement(ConditionalTooltip, { condition: !isDisabled, label: label, placement: "bottom" },
        React.createElement(Box, null,
            React.createElement(IconButton, { "data-testid": "thumb_up_button", minH: "24px", minW: "24px", size: "xs", variant: "ghost", "aria-label": label, icon: Icon, isDisabled: isDisabled, ...rest }))));
};
export default RatingButton;
